import { Observable } from 'rxjs';

export abstract class IHasPrivilege {
    public abstract hasPrivilege$(
        ...privilegeData: string[]
    ): Observable<boolean>;
}
